import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    nombre: '',
    email: '',
    password: '',
    password2: '',
    establecimiento_nombre: '',
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password.length < 6) {
      setError('La contrasena debe tener al menos 6 caracteres.');
      return;
    }
    if (form.password !== form.password2) {
      setError('Las contrasenas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      const res = await authAPI.registerDemo({
        nombre: form.nombre,
        email: form.email,
        password: form.password,
        establecimiento_nombre: form.establecimiento_nombre,
      });
      const { access_token, user } = res.data;
      localStorage.setItem('token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      navigate('/dashboard');
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al crear la cuenta.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-600 rounded-full mb-4">
            <span className="text-4xl">🐄</span>
          </div>
          <h1 className="text-4xl font-bold text-green-800 mb-2">TKorveX</h1>
          <p className="text-gray-600">Crea tu cuenta gratuita</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-1">Registrarse</h2>
          <p className="text-sm text-gray-500 mb-6">Trial gratuito 14 dias — hasta 500 animales</p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm" data-testid="register-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="register-form">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nombre completo</label>
              <input
                type="text" name="nombre" value={form.nombre} onChange={handleChange} required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition"
                placeholder="Juan Perez"
                data-testid="register-nombre"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email" name="email" value={form.email} onChange={handleChange} required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition"
                placeholder="tu@email.com"
                data-testid="register-email"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del Establecimiento</label>
              <input
                type="text" name="establecimiento_nombre" value={form.establecimiento_nombre} onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition"
                placeholder="Mi Establecimiento (opcional)"
                data-testid="register-establecimiento"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contrasena</label>
              <input
                type="password" name="password" value={form.password} onChange={handleChange} required minLength={6}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition"
                placeholder="Minimo 6 caracteres"
                data-testid="register-password"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar contrasena</label>
              <input
                type="password" name="password2" value={form.password2} onChange={handleChange} required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition"
                placeholder="Repite la contrasena"
                data-testid="register-password2"
              />
            </div>
            <button
              type="submit" disabled={loading}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 disabled:opacity-50"
              data-testid="register-submit"
            >
              {loading ? 'Creando cuenta...' : 'Crear Cuenta Gratis'}
            </button>
          </form>

          <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-xs text-green-700">
              <strong>Trial incluye:</strong> 14 dias gratis, hasta 500 animales, usuarios ilimitados, 1 establecimiento.
              Podes actualizar a un plan superior en cualquier momento.
            </p>
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              ¿Ya tenes cuenta?{' '}
              <Link to="/login" className="text-green-600 hover:text-green-800 font-semibold" data-testid="link-to-login">
                Iniciar Sesion
              </Link>
            </p>
          </div>
        </div>

        <div className="text-center mt-6 text-sm text-gray-600">
          <p>TKorveX v2.0 - Plataforma de Gestion Ganadera Inteligente</p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
